module.exports = __webpack_public_path__ + "img/white copy.45a86e21.svg";